export const getCustomerMovementTypeLabel = (type: string) => {
  if (type === 'charge') return 'Consumo';
  if (type === 'payment') return 'Pago';
  return type || '—';
};

/** Etiqueta legible en historial (distingue anulaciones de pagos normales). */
export const getCustomerMovementDisplayLabel = (movement: {
  type: 'charge' | 'payment';
  note?: string | null;
  linkedSaleStatus?: 'active' | 'voided' | null;
}) => {
  const note = movement.note?.trim() ?? '';
  if (movement.type === 'payment' && note.startsWith('Anulación venta POS')) {
    return 'Anulación de venta';
  }
  if (movement.type === 'charge' && movement.linkedSaleStatus === 'voided') {
    return 'Consumo (venta anulada)';
  }
  return getCustomerMovementTypeLabel(movement.type);
};

/** Etiqueta del medio de cobro de un pago de cuenta corriente. */
export const getCustomerPaymentMethodLabel = (methodId: string | null | undefined): string => {
  switch (methodId) {
    case 'cash':
      return 'Efectivo';
    case 'transfer':
      return 'Transferencia';
    case 'card':
      return 'Tarjeta';
    case 'mercadopago_qr':
      return 'QR Mercado Pago';
    case 'cheque':
      return 'Cheque';
    default:
      return methodId ?? '';
  }
};
